import { Link } from 'react-router-dom';

const testimonials = [
  {
    name: '小柯',
    role: '补番党',
    avatar: 'ri-user-heart-line',
    text: '寒假靠羞羞动漫网把好几部积压的番看完了。每话讲了什么写得很清楚，补番进度一下子快了很多。',
  },
  {
    name: '阿原',
    role: '追更党',
    avatar: 'ri-fire-line',
    text: '每周追番最怕断片，这里的最新分集更新很及时，配合剧情梳理回看也方便。',
  },
  {
    name: '鹿屿',
    role: '剧情回顾党',
    avatar: 'ri-movie-2-line',
    text: '想回忆某段伏笔的时候，按话找简介比重看整集省事太多，故事线梳理也很清晰。',
  },
];

export default function Testimonials() {
  return (
    <>
      <section className="bg-background-100">
        <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
          <div className="text-center">
            <span className="inline-flex items-center gap-1.5 text-xs font-medium uppercase tracking-wider text-primary-600">
              <i className="ri-heart-fill" /> 用户口碑
            </span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">补番党都在怎么说</h2>
            <p className="mx-auto mt-2 max-w-2xl text-sm text-foreground-700 md:text-base">
              从补番到追更，再到剧情回顾，羞羞动漫网帮动漫爱好者把每一部番都看得更明白。
            </p>
          </div>

          <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-5">
            {testimonials.map((t) => (
              <figure key={t.name} className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5">
                <div className="flex items-center gap-1 text-accent-500">
                  <i className="ri-star-fill" />
                  <i className="ri-star-fill" />
                  <i className="ri-star-fill" />
                  <i className="ri-star-fill" />
                  <i className="ri-star-fill" />
                </div>
                <blockquote className="mt-3 flex-1 text-sm leading-7 text-foreground-700">“{t.text}”</blockquote>
                <figcaption className="mt-4 flex items-center gap-3 border-t border-background-200 pt-4">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-100 text-lg text-secondary-700">
                    <i className={t.avatar} />
                  </span>
                  <div>
                    <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                    <p className="text-xs text-foreground-600">{t.role}</p>
                  </div>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </section>

      {/* CTA band */}
      <section className="relative overflow-hidden bg-foreground-950">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_120%,oklch(var(--primary-600)/0.5),transparent_50%),radial-gradient(circle_at_80%_0%,oklch(var(--accent-600)/0.4),transparent_45%)]" />
        <div className="relative mx-auto max-w-4xl px-4 py-16 text-center md:px-6 md:py-20">
          <h2 className="font-heading text-2xl font-bold text-background-50 md:text-4xl">
            想看的番，从这里开始补
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-sm leading-7 text-background-200 md:text-base">
            打开分集剧情页，按话对照每话简介，配合剧情梳理快速抓住故事线走向。
          </p>
          <div className="mt-7 flex flex-col justify-center gap-3 sm:flex-row">
            <a
              href="#episode"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600"
            >
              <i className="ri-clapperboard-fill" /> 浏览热门分集
            </a>
            <Link
              to="/about"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 bg-background-50/10 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/20"
            >
              了解羞羞动漫网
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}